/**
 * Navigation list sidebar
 */
export function setupNavigationSubMenus() {
  const menuSelectors = [
    '.navigation-list-sidebar',
    '.main-nav',
  ];
  const selector = menuSelectors
    .map((selector) => `${selector} li.menu-item-has-children`)
    .join(', ');

  document.querySelectorAll(selector)
    .forEach((item) => {

      const buttonHtml = `
        <button class="grow no-button">
          <div class="grow__icon-open">
            <i class="fas fa-plus-square"></i>
          </div>

          <div class="grow__icon-close">
            <i class="fas fa-minus-square"></i>
          </div>

          <span class="sr-only">Öppna undermeny</span>
        </button>
      `;
      item.querySelector('a').insertAdjacentHTML('afterend', buttonHtml);

      const grow = item.querySelector('.grow');
      const subMenu = item.querySelector('.sub-menu');

      if (item.classList.contains('current-page-ancestor')) {
        grow.classList.add('active');
      }

      grow.addEventListener('click', () => {
        grow.classList.toggle('active');
        $(subMenu).slideToggle(400);
      });
    });
}
